<template>
    <div id="evaluate">
      <div class="header2">
        <div class="header2Wrap">
          <div class="header2L">
            <img src="@/assets/list/logo.png" alt />
          </div>
          <div class="header2R">
            <input v-model="atSpmc" placeholder="请输入要查询的商品" type="text" name="" id="">
            <p @click="onSerach">
             <i class="fa fa-search" aria-hidden="true"></i> 
              <span>搜索</span>
            </p>
        </div>
      </div>
    </div>
    <!-- 主体 -->
    <div class="main">
      <div class="tits1">
        <span class="tits1-1">全部商品</span>
        <span class="tits1-2">（{{tableData.length}}）</span>
        <div class="header2R">
            <input v-model="atSpmc" placeholder="请输入要查询的商品" type="text" name="" id="">
            <p @click="onSerach">
             <i class="fa fa-search" aria-hidden="true"></i> 
              <span>搜索</span>
            </p>
        </div>
        <span class="tits1-3" @click="goshop()">
          <i class="fa fa-reply" aria-hidden="true"></i>
          返回商城
        </span>
      </div>
      <div class="content">
        <div class="content1">
          <div class="carTop">
            <div class="quesheng" v-show="!tableData.length">
              <img src="@/assets/list/quesheng.png" alt="">
              <p>购物车暂无在线商品，快去添加吧</p>
            </div>
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
              v-show="tableData.length"
            >
              <el-table-column type="selection" label="全选" width="55"></el-table-column>
              <el-table-column label="商品信息" width="300">
                <template slot-scope="scope">
                  <div class="imgss" @click="goDetail(scope.row.id)">
                    <img :src="$store.state.imgUrl+scope.row.atCoverUrl" alt />
                  </div>
                  <p class="imgTXT" @click="goDetail(scope.row.id)">{{scope.row.atSpmc+"-"+scope.row.standard}}</p>
                </template>
              </el-table-column>
              <el-table-column label="单价" width="120">
                <template slot-scope="scope">
                    <!-- this.tableData[index].discountFlag = true;
                    this.tableData[index].oneMoney = this.tableData[index].wholesalePrice; -->
                  <p class="xian">￥{{scope.row.oneMoney}}</p>
                  <!-- <p class="xian" v-if="scope.row.optYhlx==1">￥{{scope.row.yhjg}}</p> -->
                  <p class="yuan" v-if="scope.row.discountFlag">￥{{scope.row.salePrice}}</p>
                </template>
              </el-table-column>
              <el-table-column label="单位" prop="unit" width="100"></el-table-column>
              <el-table-column label="数量" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="num">
                    <p @click="reduce(scope.row.gwcId,scope.row.atSpsl,scope)">-</p>
                    <input
                      type="text"
                      :value="scope.row.atSpsl"
                      onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
                      onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
                      @input="throttling(calculateQuantity,scope.row.gwcId,500,$event)"
                    
                    />
                    <p @click="add(scope.row.gwcId,scope.row.atSpsl,scope.row.lsKc,scope)">+</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="金额" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span class="moneys">￥{{multiplication(scope.row.oneMoney-0,scope.row.atSpsl-0)}}</span>
                  <!-- <span class="moneys" v-if="scope.row.optYhlx!=1">￥{{multiplication(scope.row.atYpdj-0,scope.row.atSpsl-0)}}</span>
                  <span class="moneys" v-if="scope.row.optYhlx==1">￥{{multiplication(scope.row.yhjg-0,scope.row.atSpsl-0)}}</span> -->
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip>
                <template slot-scope="scope">
                  <p
                    style="cursor:pointer"
                    @click="Collection(scope.row.id)"
                    v-if="!scope.row.collectionId"
                  >移入收藏夹</p>
                  <p style="cursor:pointer" @click="del(scope.row.gwcId,'1')">删除</p>
                </template>
              </el-table-column>
            </el-table>
                        <div class="bottomWrap" v-show="tableData.length">
                            <div class="bottom">
                                <div class="bottomL">
                                    <!-- <el-checkbox
                                        v-model="checked"
                                        class="checkboxs"
                                        @change="toggleSelection(tableData)"
                                    >全选</el-checkbox>-->
                                    <span @click="del()" class="delMore">删除选中商品</span>
                                </div>
                                <p class="bottomR5" @click="submitOrder()">结算</p>
                                <div class="bottomR">
                                    <p>
                                        <span class="bottomR1">已选商品</span>
                                        <span class="bottomR2">{{num}}</span>
                                        <span class="bottomR3">合计（不含运费）</span>
                                        <span class="bottomR4">￥{{money}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="tableData2.length">
                        <div class="tits1">
                            <span class="tits1-1">已下架商品</span>
                            <span class="tits1-2">（{{tableData2.length}}）</span>
                        </div>
                        <el-table
                            ref="multipleTable2"
                            :data="tableData2"
                            tooltip-effect="dark"
                            style="width: 100%"
                            @selection-change="handleSelectionChange2"
                        >
                            <el-table-column type="selection" label="全选" width="55"></el-table-column>
                            <el-table-column label="商品信息" width="350">
                                <template slot-scope="scope">
                                    <div class="imgss">
                                        <img :src="$store.state.imgUrl+scope.row.atCoverUrl" alt />
                                    </div>
                                    <p class="imgTXT">{{scope.row.atSpmc+"-"+scope.row.standard}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价" width="120">
                                <template slot-scope="scope">
                                    <p class="yuan" v-if="scope.row.optYhlx==1">￥{{scope.row.atYpdj}}</p>
                                    <p class="xian" v-if="scope.row.optYhlx==1">￥{{scope.row.yhjg}}</p>
                                    <p class="xian" v-if="scope.row.optYhlx!=1">￥{{scope.row.atYpdj}}</p>
                                    
                                </template>
                            </el-table-column>
                            <el-table-column label="单位" prop="unit" width="100"></el-table-column>
                            <el-table-column label="数量" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div>
                                        <p style="margin-left: 5px;">{{scope.row.atSpsl}}</p>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="金额" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span
                                        class="moneys"
                                        v-if="scope.row.optYhlx!=1"
                                    >￥{{multiplication(scope.row.atYpdj-0,scope.row.atSpsl-0)}}</span>
                                    <span
                                        class="moneys"
                                        v-if="scope.row.optYhlx==1"
                                    >￥{{multiplication(scope.row.yhjg-0,scope.row.atSpsl-0)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <!-- <p style="cursor:pointer" @click="Collection(scope.row.id)">移入收藏夹</p> -->
                                    <p style="cursor:pointer" @click="del(scope.row.gwcId,'2')">删除</p>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vfooter from "@/components/common/Footer";
import topHead from "@/components/common/topHead";
import footerCopy from "@/components/common/footerCopy";
export default {
    name: "Shopping",
    data() {
        return {
            userId: "",
            checked: false,
            value1: null,
            desc: "",
            tableData: [], //在线商品
            tableData2: [], //已下架
            multipleSelection: [],
            num: 0,
            money: 0,
            multipleSelection2: [],
            num2: 0,
            money2: 0,
            atSpmc:'', // 购物车搜索字段
        };
    },
    components: {
        topHead: topHead,
        vfooter: vfooter,
        footerCopy: footerCopy
    },
    created() {
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            this.userId = this.userInfo.id;
        }

        this.getData();
        this.getData2();
    },
    methods: {
        async getData() {
            var params = {
							atSpmc:this.atSpmc
						};
            params.userId = this.userId;
            let url = "/gwcgl/getList";
            await this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    let tableData = res.data.data;
                    for (let i = 0; i < tableData.length; i++) {
                        if(tableData[i].yhjg != tableData[i].salePrice){
                            tableData[i].discountFlag = true;
                        }else{
                            tableData[i].discountFlag = false;
                        }
                        tableData[i].oneMoney =  tableData[i].yhjg;
                        }
                    this.tableData= tableData;                  
                }
            });
        },
        getData2() {
            //已下架商品
            var params = {};
            params.userId = this.userId;
            let url = "/gwcgl/listOffGwcgl";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    this.tableData2 = res.data.data;
                }
            });
        },
        add(id, num, max,scope) {
            // console.log(scope,'scope')
            let index= scope.$index;
            //加
            let nums = num - 0 + 1; //转换类型
            if (nums > parseInt(max)) {
                // nums = max;
                this.$message({
                    message: "商品数量以达最大库存量",
                    type: "warning"
                });
                return false;
            }
            var params = {};
            params.id = id;
            params.atSpsl = nums;
            let url = "/gwcgl/update";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    // this.getData();
                    this.tableData[index].atSpsl+=1;
                    this.count(index);
                    this.addNumber();
                    // console.log(this.tableData[index])
                }
            });
        },
        reduce(id, num,scope) {
            let index= scope.$index;
            //减
            let nums = num - 0 - 1; //转换类型
            if (nums < 1) {
                nums = 1;
                this.$message({
                    message: "商品数量不能小于1",
                    type: "warning"
                });
                return false
            }
            var params = {};
            params.id = id;
            params.atSpsl = nums;
            let url = "/gwcgl/update";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    // this.getData();
                    this.tableData[index].atSpsl= this.tableData[index].atSpsl-1;
                    this.count(index);
                    this.addNumber();
                }
            });
        },
        count(index) {
            const row = this.tableData[index];
            let discountFlag = false;
            let oneMoney = row.salePrice;

            if (this.userInfo.isMerchant == 1 && row.merchantCount) {
                const isReachMerchantCount = row.atSpsl === row.merchantCount || row.atSpsl > row.merchantCount;
                if (isReachMerchantCount) {
                    discountFlag = true;
                    oneMoney = row.merchantPrice;
                } else {
                    if (row.wholesalePrice) {
                        const isReachWholesaleCount = row.atSpsl === row.wholesaleCount || row.atSpsl > row.wholesaleCount;
                        if (isReachWholesaleCount) {
                            discountFlag = true;
                            oneMoney = row.wholesalePrice;
                        } else {
                            discountFlag = this.shouldApplyDiscount(row);
                            oneMoney = discountFlag? row.yhjg : row.salePrice;
                        }
                    } else {
                        discountFlag = this.shouldApplyDiscount(row);
                        oneMoney = discountFlag? row.yhjg : row.salePrice;
                    }
                }
            } else {
                if (row.wholesalePrice) {
                    const isReachWholesaleCount = row.atSpsl === row.wholesaleCount || row.atSpsl > row.wholesaleCount;
                    if (isReachWholesaleCount) {
                        discountFlag = true;
                        oneMoney = row.wholesalePrice;
                    } else {
                        discountFlag = this.shouldApplyDiscount(row);
                        oneMoney = discountFlag? row.yhjg : row.salePrice;
                    }
                } else {
                    discountFlag = this.shouldApplyDiscount(row);
                    oneMoney = discountFlag? row.yhjg : row.salePrice;
                }
            }

            row.discountFlag = discountFlag;
            row.oneMoney = oneMoney;
        },
        addNumber(){
            if(!this.multipleSelection.length){
                return false
            }
            var data = 0;
            for (var i = 0; i < this.multipleSelection.length; i++) {
                    data +=
                        parseFloat(this.multipleSelection[i].oneMoney) *
                        parseFloat(this.multipleSelection[i].atSpsl);
            }
            this.money = data.toFixed(2); //保留两位小数
        },
        shouldApplyDiscount(row) {
            return row.optYhlx < 3;
        },
        //节流
        throttling(fn,id,timeVal,e){
            if (this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(() => {
                fn(id,e);
            }, timeVal)
        },
        async calculateQuantity(id,e) {
            e.target.blur();
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var params = {};
            params.id = id;
            params.atSpsl = e.target.value==""?1:e.target.value;
            let url = "/gwcgl/update";
            let res = await this.$http.post(url, params);
            if (res.data.code == 200) {
                console.log(res, 456);
                await this.getData();
            }
            loading.close();
        },
        goshop() {
            this.$router.push({ path: "/commodity" });
        },
        del(id,type) {
            // //删除
            // if (this.multipleSelection.length == 0) {
            //     this.$message({
            //         type: "error",
            //         message: "请选择要删除的商品!"
            //     });
            //     return false;
            // }
            this.$confirm(
                "此操作将从购物车永久删除选中商品, 是否继续?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            ).then(() => {
                var params = {};
                params.ids = [];
                if (id) {
                    params.ids.push(id);
                } else {
                    for (var i = 0; i < this.multipleSelection.length; i++) {
                        params.ids.push(this.multipleSelection[i].gwcId);
                    }
                }
                let url = "/gwcgl/delete";
                this.$http.post(url, params).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        if(type&&type==1){
                            this.getData();//刷新上架的数据
                        }else if(type&&type==2){
                            this.getData2()//刷新失效的数据
                        }else{
                            this.getData();//刷新全部数据
                            this.getData2()
                        }
                       
                    }
                });
            });
        },
        Collection(id) {
            //移入收藏夹
            let url = "/common/collection";
            var params = {};
            params.id = id;
            params.userId = this.userId;
            params.type = "2";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        type: "success",
                        message: "加入收藏夹成功!"
                    });
                    this.getData();
                }
            });

        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {			
            this.multipleSelection = val;
            this.num = this.multipleSelection.length;
            if (this.num == this.tableData.length) {
                this.checked = true;
            } else {
                this.checked = false;
            }
            var data = 0;
            for (var i = 0; i < this.multipleSelection.length; i++) {
                    data +=
                        parseFloat(this.multipleSelection[i].oneMoney) *
                        parseFloat(this.multipleSelection[i].atSpsl);
            }
            this.money = data.toFixed(2); //保留两位小数
        },
        handleSelectionChange2(val) {
            //已下架商品
            this.multipleSelection2 = val;
            this.num2 = this.multipleSelection.length;
            if (this.num2 == this.tableData2.length) {
                this.checked2 = true;
            } else {
                this.checked2 = false;
            }
            var data = 0;
            for (var i = 0; i < this.multipleSelection2.length; i++) {
                data +=
                    parseFloat(this.multipleSelection2[i].yhjg) *
                    parseFloat(this.multipleSelection2[i].atSpsl);
            }
            this.money2 = data.toFixed(2); //保留两位小数
        },
        submitOrder() {
            if (this.multipleSelection.length == 0) {
                this.$message.error("请选择结算商品");
                return false;
            } else {
                let data={};
				data.userId = this.userId;
                var arr = [];
                for (var i = 0; i < this.multipleSelection.length; i++) {
                        arr.push({
                            spSpgl: this.multipleSelection[i].id,
                            atSpsl: this.multipleSelection[i].atSpsl,
                            spSpgg : this.multipleSelection[i].spSpgg, //规格的id
                            spSpggDetail : this.multipleSelection[i].spSpggDetail, //规格明细的id
                            isWholesale : this.multipleSelection[i].atSpsl > this.multipleSelection[i].wholesaleCount || this.multipleSelection[i].atSpsl ==this.multipleSelection[i].wholesaleCount ? 1 : 0,//是否批发 0：否，1：是
                            spYhxx: this.multipleSelection[i].optYhlx == 1?this.multipleSelection[i].yhxxId:null
                        });
                }
                data.ddmxList = arr;
                sessionStorage.setItem("ddmxList", JSON.stringify(data)); //存储获取订单所需数据
                this.$router.push({
                    path: "/ReceivingAddress",
                    query: { type: 1 } //type:生成订单入口区分（0 商品详情生成订单 1：购物车生成订单）
                });
            }
        },
        goDetail(id) {
            //跳转商品详情
            this.$router.push({ path: "/ProductDetails/" + id });
        },
        onSerach(){
            this.getData()
            this.handleSelectionChange([])
        }
    }
};
</script>
<style scoped>
.main {
    max-width: 1440px;
    width: 1024px;
    height: 100%;
    margin: 0px auto;
}
.cont .main{
    width: auto;
}
.header2 {
    width: 100%;
    height: 94px;
    background-color: #f64420;
}
.header2Wrap {
    max-width: 1440px; 
    width: 1024px;
    height: 100%;
    margin: 0px auto;
}
.header2L {
    float: left;
    width: 280px;
    height: 80%;
    margin-top: 10px;
}
.header2L img {
    width: 100%;
    height: 100%;
}
.header2R {
    float: right;
    width: 50%;
    height: 35px; 
}
.header2R input {
    display: block;
    float: left;
    width: 360px;
    height: 32px;
    background-color: #ffffff;
    border: none;
    color:#999;
		padding:0 20px;
		    outline: 0;
}
.header2R p {
    float: left;
    width: 65px;
    height: 32px;
    line-height: 32px;
    background-color: #ffffff;
    margin-left: 10px;
    text-align: center;
    cursor: pointer;
    color:#999;
}
.tits1 {
    width: 100%;
    height: 30px;
    line-height: 30px;
    display: flex;
    align-items: center;
    margin: 15px 0;
    position: relative;
}
.tits1-1 {
    font-size: 22px;
    font-weight: normal;
    letter-spacing: 1px;
    color: #333333;
}
.tits1-2 {
    font-size: 22px;
    font-weight: normal;
    letter-spacing: 1px;
    color: #f64420;
}
.tits1-3 {
    float: right;
    display: block;
    width: 107px;
    height: 32px;
    line-height: 32px;
    background-color: #ffffff;
    border-radius: 4px;
    border: solid 1px #dddddd;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 1px;
    color: #f64420;
    text-align: center;
    cursor: pointer;
    position: absolute;
    right: 0;
}

.content {
    width: 100%;
}
.content::after {
    content: "";
    height: 0;
    clear: both;
    overflow: hidden;
    display: block;
    visibility: hidden;
}
.imgss {
    float: left;
    width: 120px;
    height: 86px;
    background-color: #cbbcb9;
    overflow: hidden;
    cursor: pointer;
}
.imgss img {
    width: 100%;
    min-height: 100%;
}
.active {
    opacity: 0.6;
}
.imgTXT {
    float: left;
    width: 145px;
    height: 30px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 1px;
    color: #333333;
    margin-top: 10px;
    margin-left: 10px;
    cursor: pointer;
}
.imgTXT:hover {
    color: #f64420;
}
.yuan {
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 1px;
    color: #999999;
    text-decoration: line-through;
    margin-top: 5px;
}
.xian {
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 16px;
    letter-spacing: 1px;
    color: #f64420;
}
.num p {
    float: left;
    width: 25px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    background-color: #f6f6f6;
    border: solid 1px #dddddd;
    cursor: pointer;
}
.num input {
    display: block;
    float: left;
    width: 50px;
    height: 23px;
    text-align: center;
    border: solid 1px #dddddd;
}
.moneys {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 16px;
    letter-spacing: 1px;
    color: #f64420;
}

.content1 {
    margin-bottom: 30px;
}
.carTop {
    position: relative;
    margin-bottom: 70px;
}
.bottomWrap {
    position: absolute;
    left: 0;
    bottom: -60px;
    width: 99.9%;
    height: 60px;
    background-color: #f0f0f0;
    border: solid 1px #dddddd;
    z-index: 999;
}
.bottom {
    /* max-width: 90%; */
    width: 100%;
    height: 100%;
    margin: 0px auto;
}
.bottomL {
    float: left;
    height: 60px;
    line-height: 60px;
}
.checkboxs {
    float: left;
    font-size: 16px;
}
.bottomL span {
    float: left;
    display: block;
    margin-left: 30px;
    cursor: pointer;
}
.bottomL span:hover {
    color: #f64420;
}
.bottomR {
    float: right;
    height: 60px;
    line-height: 60px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #666666;
}
.bottomR2 {
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 1px;
    color: #f64420;
}
.bottomR4 {
    font-size: 22px;
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #f64420;
}
.bottomR5 {
    float: right;
    width: 140px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: #f64420;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #ffffff;
    cursor: pointer;
    margin-left: 30px;
}

/* 缺省图 */
.quesheng{
  width:100%;
  height:500px;
}
.quesheng img{
  display:block;
  width:40%;
  margin:0 auto;
}
.quesheng p{
  width:100%;
  height:30px;
  line-height: 30px;
  text-align: center;
  font-weight: 600;
  margin-top:20px;
}
#evaluate .header2 .header2Wrap{
    display: flex;    
    justify-content: space-between;
    align-items: center;
}
.main .header2R{
    display: none;
}
.home-box .header2{
    display: none;
}
.home-box .main .header2R{
    display: block;
}
</style>
<style >
/* #evaluate {
  height:550px;
} */
#evaluate .el-textarea__inner {
    display: block;
    height: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ShoppingMall/car.vue